import { Component } from '@angular/core';

@Component({
    selector: 'app-advancepayment-tabs',
    templateUrl: './advancepayment-tabs.component.html',
    styleUrls: [],
    standalone: false
})

export class AdvancePaymentTabsComponent {

  routes: object[];

  constructor() {
    this.routes = [
      { label: 'Anticipo', link: '/expense/advancepayment/provider', enable: true },
      { label: 'Fianzas', link: '/expense/advancepayment/bail', enable: true },
    ];
  }

}
